import { environment } from "src/environments/environment";

export const CLIENT_ID_CBL  = 'CBL';
export const CLIENT_ID_SBH  = 'SBH';
export const CLIENT_ID_TIMX = 'TMX';
export const CLIENT_ID_WAR  = 'WAR';

// setting the value as 30days for prod and 6hours for lower environments
export const EXPIRY_DAYS_FOR_AGENTID = environment.production ? 30 : 0.25;
